import React, { useState } from 'react';
import { Container, Row, Col, Card, CardBody, Button, Input, Form, Alert } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { post } from "../../helpers/api_helper";

const LockScreen = () => {
    document.title = "Verrouillage | Rakops Solutions";
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    // Get user from localStorage
    const authUserString = localStorage.getItem("authUser");
    const authData = authUserString ? JSON.parse(authUserString) : null;
    const user = authData?.user || authData;

    const handleUnlock = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            // Re-authenticate using the login endpoint
            const response = await post("/auth/login", {
                email: user.email,
                password: password
            });

            if (response && response.access_token) {
                // Update localStorage with new token if necessary, then redirect
                localStorage.setItem("authUser", JSON.stringify(response));
                navigate("/dashboard");
            }
        } catch (err) {
            setError("Mot de passe incorrect. Veuillez réessayer.");
        } finally {
            setLoading(false);
        }
    };

    const firstName = user?.first_name || '';
    const lastName = user?.last_name || '';
    const userInitials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase() || 'U';

    return (
        <React.Fragment>
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="8" lg="6" xl="5">
                            <Card className="overflow-hidden">
                                <CardBody className="pt-0">
                                    <div className="p-3">
                                        <h4 className="text-muted font-size-18 mb-1 text-center">Écran verrouillé</h4>
                                        <p className="text-muted text-center">Bonjour {firstName}, saisissez votre mot de passe pour déverrouiller l'écran !</p>

                                        {error && <Alert color="danger">{error}</Alert>}

                                        <Form className="form-horizontal mt-4" onSubmit={handleUnlock}>
                                            <div className="user-thumb text-center mb-4">
                                                <div
                                                    className="rounded-circle avatar-md img-thumbnail mx-auto d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: '80px',
                                                        height: '80px',
                                                        backgroundColor: '#556ee6',
                                                        color: 'white',
                                                        fontWeight: '600',
                                                        fontSize: '24px'
                                                    }}
                                                >
                                                    {userInitials}
                                                </div>
                                                <h6 className="font-size-16 mt-3">{firstName} {lastName}</h6>
                                            </div>

                                            <div className="mb-3">
                                                <label htmlFor="userpassword">Mot de passe</label>
                                                <Input
                                                    name="password"
                                                    className="form-control"
                                                    type="password"
                                                    placeholder="Saisissez votre mot de passe"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="mb-3 row">
                                                <div className="col-12 text-end">
                                                    <Button
                                                        color="primary"
                                                        className="w-md waves-effect waves-light"
                                                        type="submit"
                                                        disabled={loading}
                                                    >
                                                        {loading ? "Déverrouillage..." : "Déverrouiller"}
                                                    </Button>
                                                </div>
                                            </div>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="mt-5 text-center">
                                <p>Ce n'est pas vous ? <Link to="/logout" className="text-primary font-weight-bold"> Se déconnecter </Link> </p>
                                <p>© {new Date().getFullYear()} Rakops Solutions. Construit avec passion.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default LockScreen;
